import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {sysCode, title, taskId, userId, userAccount, userName, departmentId, departmentName, unityUserId, status, nodeId, nodeName, result, startTime, endTime, url}
 * @param query: {}
 * @returns Promise
 */
export function addTaskReceiver(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/taskReceiver/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {unityUserId, status, result, userId, userName, userAccount, endTime, url, where: {id, taskId, userId, nodeId, sysCode}}
 * @param query: {}
 * @returns Promise
 */
export function editTaskReceiver(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/taskReceiver/edit',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function deleteTaskReceiver(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/taskReceiver/delete',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, queryFields}
 * @param query: {}
 * @returns Promise
 */
export function getTaskReceiver(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/taskReceiver/info',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {queryFields, key, sysCode, taskId, flowId, userId, userAccount, unityUserId}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findTaskReceiverPage(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/taskReceiver/page',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

